import { createSelector } from 'reselect';

const selectOpennetworkLogs = (state: any) => state.opennetworkLogs;


export const selectOpennetworkLogsCurrentItem = createSelector([selectOpennetworkLogs], (opennetworkLogs) => opennetworkLogs.current);

export const selectOpennetworkLogsListItems = createSelector([selectOpennetworkLogs], (opennetworkLogs) => opennetworkLogs.list);

export const selectOpennetworkLogsItemById = (itemId: any) =>
    createSelector(selectOpennetworkLogsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOpennetworkLogsCreatedItem = createSelector([selectOpennetworkLogs], (opennetworkLogs) => opennetworkLogs.create);

export const selectOpennetworkLogsQueryItems = createSelector([selectOpennetworkLogs], (opennetworkLogs) => opennetworkLogs.query);

export const selectOpennetworkLogsUpdatedItem = createSelector([selectOpennetworkLogs], (opennetworkLogs) => opennetworkLogs.update);

export const selectOpennetworkLogsReadItem = createSelector([selectOpennetworkLogs], (opennetworkLogs) => opennetworkLogs.read);

export const selectOpennetworkLogsDeletedItem = createSelector([selectOpennetworkLogs], (opennetworkLogs) => opennetworkLogs.delete);

export const selectOpennetworkLogsSearchedItems = createSelector([selectOpennetworkLogs], (opennetworkLogs) => opennetworkLogs.search);

export const selectOpennetworkLogsItemsCount = createSelector([selectOpennetworkLogs], (opennetworkLogs) => opennetworkLogs.count);

export const selectOpennetworkLogsItemsFilter = createSelector([selectOpennetworkLogs], (opennetworkLogs) => opennetworkLogs.filter);